import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";

const SubCompanyActivityFilter = ({
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false
}) => {
    const {t} = useTranslation();
    return (
        <React.Fragment>
            {showLabel && <h5>{"Alt Firma Aktiflik"}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="sub_company_activity"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
            >
                {showAllOption ? (
                    <SelectField.Option data-testid="sub_company_activity_all_option" value={"all"}>
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                ) : (
                    <></>
                )}
                <SelectField.Option data-testid="sub_company_activity_option" value={"active"}>
                    Aktif
                </SelectField.Option>
                <SelectField.Option data-testid="sub_company_activity_option" value={"disabled"}>
                    Pasif
                </SelectField.Option>
            </SelectField>
        </React.Fragment>
    );
};

export default SubCompanyActivityFilter;
